function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button as BaseButton } from "sprout-ui-dom/dist/Button";
import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { media, themeGet } from "sprout-ui-theme";
import { ExtensionOutlined, FeedbackOutlined, Help, KeyboardOutlined, MailOutlined } from "sprout-ui-icons";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { MenuTrigger, MenuItem, MenuTitle, useMenuState, Menu as BaseMenu } from "@sprout/list-navigation/dist/Menu";
import { useMergeRefs } from "sprout-hooks";
import { useRouteMatch } from "react-router";
import AppHelpMenuKeyboardShortcuts from "./AppHelpMenuKeyboardShortcuts";
const FirstMenu = styled(BaseMenu)`
  max-width: 280px;
`;
const Button = styled(BaseButton)`
  width: 32px;
  height: 32px;
  border: 1px solid ${themeGet("colors.black.12")};
  background: ${themeGet("colors.white.100")};

  position: fixed;
  bottom: 16px;
  right: 16px;

  ${media.target("touch")} {
    display: none;
  }

  ${media.down("medium", "pointer")} {
    display: none;
  }
`;
const AppHelpMenu = ()=>{
    const menuState = useMenuState();
    const secondaryMenuState = useMenuState();
    const mergedReferenceElement = useMergeRefs(menuState.setReferenceElement, secondaryMenuState.setReferenceElement);
    const { onOpenChange  } = menuState;
    const { onOpenChange: onShortcutMenuOpenChange  } = secondaryMenuState;
    const isShortcutsPage = useRouteMatch({
        exact: true,
        path: "/shortcuts"
    });
    useActionRegistryGlobalHandler("SHORTCUTS", useCallback(()=>{
        onShortcutMenuOpenChange(true);
        return true;
    }, [
        onShortcutMenuOpenChange
    ]), {
        skip: !!isShortcutsPage
    });
    const handleShortcutClick = useCallback(()=>{
        onShortcutMenuOpenChange(true);
    }, [
        onShortcutMenuOpenChange
    ]);
    useActionRegistryGlobalHandler("ESCAPE", useCallback(()=>{
        onOpenChange(false);
        onShortcutMenuOpenChange(false);
        return true;
    }, [
        onOpenChange,
        onShortcutMenuOpenChange
    ]), {
        skip: !menuState.open && !secondaryMenuState.open
    });
    const [showExtension, setShowExtension] = useState(false);
    useEffect(()=>{
        if (window.chrome) setShowExtension(true);
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                setReferenceElement: mergedReferenceElement,
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "circle",
                    children: /*#__PURE__*/ _jsx(Help, {})
                })
            })),
            /*#__PURE__*/ _jsxs(FirstMenu, _objectSpread({}, menuState, {
                $size: "md",
                placement: "top-end",
                children: [
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        children: "Sprout Help"
                    }),
                    showExtension && /*#__PURE__*/ _jsx(MenuItem, {
                        icon: ExtensionOutlined,
                        truncate: false,
                        label: "Get the browser button to save links faster",
                        href: "https://chrome.google.com/webstore/detail/sprout-save-button/acgadgpicnkggmbimkcefdeeendeiflf",
                        _blank: true
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        icon: KeyboardOutlined,
                        label: "Keyboard shortcuts",
                        onClick: handleShortcutClick
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        icon: MailOutlined,
                        label: "Contact support",
                        href: "mailto:support@sprout.io"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        icon: FeedbackOutlined,
                        label: "Send feedback",
                        href: "mailto:feedback@sprout.io"
                    })
                ]
            })),
            /*#__PURE__*/ _jsx(BaseMenu, _objectSpread({}, secondaryMenuState, {
                $size: "328px",
                placement: "top-end",
                children: /*#__PURE__*/ _jsx(AppHelpMenuKeyboardShortcuts, {})
            }))
        ]
    });
};
export default AppHelpMenu;
